import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { Block, Save } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import React, { memo, useRef } from "react";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import {
  FORM_PRINT,
  FORM_PRINT_ADVANCE,
  FORM_PRINT_A5,
  FORM_PRINT_A5_RECEIPT,
  FORM_PRINT_A5_SERVICE_SINGLE,
  FORM_PRINT_A5_SYNTHETIC,
  FORM_PRINT_SERVICE_SINGLE,
  FORM_PRINT_THERMAL,
  FORM_PRINT_THERMAL_RECEIPT,
  FORM_PRINT_THERMAL_SYNTHETIC,
  VOUCHER_INVOICE_TYPE_VALUE,
} from "app/common/LocalConst";
import { useReactToPrint } from "react-to-print";
import { POSITION_CONSULTANT } from "app/appConfig";
import PrintFormA5 from "../Print/PrintFormA5";
import PrintFormApi from "../Print/PrintFormApi";
import PrintFormThermalSynthetic from "../Print/PrintFormThermalSynthetic";
import PrintFormA5s from "../Print/PrintFormA5s";
import PrintFormRetailProductService from "../Print/PrintFormRetailProductService";
import PrintFormRetailProductServiceA5 from "../Print/PrintFormRetailProductServiceA5";
import { getPositionKTV } from "app/common/LocalFunction";
import PrintFormHeatReceipt from "../Print/PrintFormHeatReceipt";
import PrintFormReceiptA5 from "../Print/PrintFormReceiptA5";
import {FEE_VOUCHER_PRINT_VERSION} from "app/appConfig";
import PrintFormApiV2 from "../Print/V2/PrintFormApiV2";
import PrintFormReceiptA5V2 from "../Print/V2/PrintFormReceiptA5V2";
import PrintFormHeatReceiptV2 from "../Print/V2/PrintFormHeatReceiptV2";
import PrintFormA5V2 from "../Print/V2/PrintFormA5V2";
import PrintFormRetailProductServiceA5V2 from "../Print/V2/PrintFormRetailProductServiceA5V2";
import PrintFormRetailProductServiceV2 from "../Print/V2/PrintFormRetailProductServiceV2";
import PrintFormA5sV2 from "../Print/V2/PrintFormA5sV2";
import PrintFormThermalSyntheticV2 from "../Print/V2/PrintFormThermalSyntheticV2";
const PrintPopupApi = ({
  open,
  handleClose,
  dataVoucherFee,
  rowDataVoucher,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "In phiếu",
  });
  let methodVoucherAdvance =
    dataVoucherFee?.voucherInvoiceType === VOUCHER_INVOICE_TYPE_VALUE.Advance
      ? FORM_PRINT_THERMAL
      : FORM_PRINT_SERVICE_SINGLE;

  const handlePrintAndClose = async () => {
    try {
      // gọi hàm in
      await handlePrint();
      setTimeout(() => {
        handleClose();
      }, 300);
    } catch (error) {
      console.error("Lỗi khi in:", error);
    }
  };

  return (
    <PopupForm
      open={open}
      size="xxl"
      height="75vh"
      handleClose={handleClose}
      title={"In phiếu"}
      formik={{
        initialValues: {
          methodPrint: methodVoucherAdvance,
        },
        onSubmit: async (values) => {
          console.log("Data", values);
        },
        enableReinitialize: true,
      }}
      action={(values) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton type="submit" onClick={handlePrintAndClose}>
              {!isMobile && <Save className="mr-2 " />}
              In phiếu và đóng
            </CommonButton>
            <CommonButton type="submit" onClick={handlePrint}>
              {!isMobile && <Save className="mr-2 " />}
              In phiếu
            </CommonButton>

            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <ValueForm
              componentRef={componentRef}
              dataVoucherFee={dataVoucherFee}
              rowDataVoucher={rowDataVoucher}
            />
          </>
        );
      }}
    </PopupForm>
  );
};

const ValueForm = observer(
  ({ componentRef, dataVoucherFee, rowDataVoucher }) => {
    const { values, setFieldValue } = useFormikContext();
    const POSITION_KTVS_CONSULTANT = [...getPositionKTV(), POSITION_CONSULTANT];

    const staffRevenuesConsultant =
      (dataVoucherFee?.items?.length > 0 &&
        dataVoucherFee?.items?.flatMap((el) =>
          el?.staffRevenues?.filter((staff) =>
            POSITION_KTVS_CONSULTANT.some(
              (pos) => pos === staff?.position?.code
            )
          )
        )) ||
      [];
    const mapStaffRevenuesConsultant = Array.from(
      new Map(
        staffRevenuesConsultant?.map((item) => [item?.staff?.id, item])
      ).values()
    );
    const methodPrint = values.methodPrint;
    let optionsVoucherAdvance =
      dataVoucherFee?.voucherInvoiceType === VOUCHER_INVOICE_TYPE_VALUE.Advance
        ? FORM_PRINT_ADVANCE
        : FORM_PRINT;
    console.log("dataVoucherFee", dataVoucherFee);
    console.log("FEE_VOUCHER_PRINT_VERSION", FEE_VOUCHER_PRINT_VERSION);

    return (
      <>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={3}>
            <GlobitsSelectInput
              label="Loại mẫu phiếu"
              name="methodPrint"
              options={optionsVoucherAdvance}
              onChange={(e) => {
                setFieldValue("methodPrint", e?.target?.value);
              }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            className="flex-center"
            style={{ border: "1px dashed black", margin: "5px" }}
          >
            {methodPrint === FORM_PRINT_THERMAL_SYNTHETIC ? (
              // Mẫu in nhiệt (tổng hợp)
              FEE_VOUCHER_PRINT_VERSION === "v2" ? (
                <PrintFormThermalSyntheticV2
                  componentRef={componentRef}
                  dataVoucherFee={dataVoucherFee}
                  staffRevenues={mapStaffRevenuesConsultant}
                />
              ) : (
                <PrintFormThermalSynthetic
                  componentRef={componentRef}
                  dataVoucherFee={dataVoucherFee}
                  staffRevenues={mapStaffRevenuesConsultant}
                />
              )
            ) : methodPrint === FORM_PRINT_A5_SYNTHETIC ? (
              // Mẫu in A5 (tổng hợp)
              FEE_VOUCHER_PRINT_VERSION === "v2" ? (
                <PrintFormA5sV2
                  componentRef={componentRef}
                  dataVoucherFee={dataVoucherFee}
                  staffRevenues={mapStaffRevenuesConsultant}
                />
              ) : (
                <PrintFormA5s
                componentRef={componentRef}
                  dataVoucherFee={dataVoucherFee}
                  staffRevenues={mapStaffRevenuesConsultant}
                />
              )
            ) : methodPrint === FORM_PRINT_SERVICE_SINGLE ? (
              // Mẫu in nhiệt (In DVSP lẻ)
              FEE_VOUCHER_PRINT_VERSION === "v2" ? (
                <PrintFormRetailProductServiceV2
                componentRef={componentRef}
                dataVoucherFee={dataVoucherFee}
                staffRevenues={mapStaffRevenuesConsultant}
                rowDataVoucher={rowDataVoucher}
              />
              ) : (
                <PrintFormRetailProductService
                  componentRef={componentRef}
                  dataVoucherFee={dataVoucherFee}
                  staffRevenues={mapStaffRevenuesConsultant}
                  rowDataVoucher={rowDataVoucher}
                />
              )
            ) : methodPrint === FORM_PRINT_A5_SERVICE_SINGLE ? (
              // Mẫu in A5 (In DVSP lẻ)
              FEE_VOUCHER_PRINT_VERSION === "v2" ? (
                <PrintFormRetailProductServiceA5V2
                componentRef={componentRef}
                  dataVoucherFee={dataVoucherFee}
                  staffRevenues={mapStaffRevenuesConsultant}
                  rowDataVoucher={rowDataVoucher}
                />
              ) : (
                <PrintFormRetailProductServiceA5
                  componentRef={componentRef}
                  dataVoucherFee={dataVoucherFee}
                  staffRevenues={mapStaffRevenuesConsultant}
                  rowDataVoucher={rowDataVoucher}
                />
              )
            ) : methodPrint === FORM_PRINT_A5 ? (
              //  Mẫu in A5 - CT
              FEE_VOUCHER_PRINT_VERSION === "v2" ? (
                <PrintFormA5V2
                componentRef={componentRef}
                dataVoucherFee={dataVoucherFee}
                staffRevenues={mapStaffRevenuesConsultant}
                />
              ) : (
                <PrintFormA5
                  componentRef={componentRef}
                  dataVoucherFee={dataVoucherFee}
                  staffRevenues={mapStaffRevenuesConsultant}
                />
              )
            ) : methodPrint === FORM_PRINT_THERMAL_RECEIPT ? (
              // mấu in nhiệt phiếu thu
              FEE_VOUCHER_PRINT_VERSION === "v2" ? (
                <PrintFormHeatReceiptV2
                componentRef={componentRef}
                dataVoucherFee={dataVoucherFee}
                staffRevenues={mapStaffRevenuesConsultant}
                />
              ) : (
                <PrintFormHeatReceipt
                  componentRef={componentRef}
                  dataVoucherFee={dataVoucherFee}
                  staffRevenues={mapStaffRevenuesConsultant}
                />
              )
            ) : methodPrint === FORM_PRINT_A5_RECEIPT ? (
              // mấu in A5 phiếu thu
              FEE_VOUCHER_PRINT_VERSION === "v2" ? (
                <PrintFormReceiptA5V2
                componentRef={componentRef}
                dataVoucherFee={dataVoucherFee}
                staffRevenues={mapStaffRevenuesConsultant}
                />
              ) : (
                <PrintFormReceiptA5
                  componentRef={componentRef}
                  dataVoucherFee={dataVoucherFee}
                  staffRevenues={mapStaffRevenuesConsultant}
                />
              )
            ) : (
              // mặc định in là vào bill này in nhiệt CT
              FEE_VOUCHER_PRINT_VERSION === "v2" ? (
                <PrintFormApiV2
                componentRef={componentRef}
                dataVoucherFee={dataVoucherFee}
                staffRevenues={mapStaffRevenuesConsultant}
                />
              ) : (
                <PrintFormApi
                  componentRef={componentRef}
                  dataVoucherFee={dataVoucherFee}
                  staffRevenues={mapStaffRevenuesConsultant}
                />
              )
            )}
          </Grid>
        </Grid>
      </>
    );
  }
);

export default memo(observer(PrintPopupApi));
